<template>
  <tr class="text-center relative-tutorial-content">
    <td>{{ user.id }}</td>
    <td>{{ user.firstname }}</td>
    <td>{{ user.lastname }}</td>
    <td>{{ user.email }}</td>
    <td>{{ user.empresa?.name ?? user.client?.name ?? "" }}</td>
    <td>{{ user.statistics?.registered_routes ?? 0 }}</td>
    <td>{{ user.statistics?.routes_completed ?? 0 }}</td>
    <td>{{ user.statistics?.insignia ?? 0 }}</td>
    <td style="width: 200px">
      <div class="small fw-bold">
        {{ user.created_at_convert ?? "-" }}
      </div>
    </td>
    <td>
      <button 
        type="button" 
        class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
        title="Ver detalles" 
        @click="$emit('edit', user)"
      >
        <i class="fa-solid fa-eye"></i>
      </button>

      <TutorialCard
        v-if="showTutorial"
        @close="$emit('close-tutorial')"
        @open-video="$emit('open-tutorial-video')"
      />
    </td>
  </tr>
</template>

<script>
import TutorialCard from './TutorialCard.vue'

export default {
  name: 'UserTableRow',
  
  components: {
    TutorialCard
  },

  props: {
    user: { type: Object, required: true },
    index: { type: Number, required: true },
    showTutorial: { type: Boolean, default: false }
  },

  emits: ['edit', 'close-tutorial', 'open-tutorial-video']
}
</script>

<style scoped>
.relative-tutorial-content {
  position: relative;
}
</style>